import { useLang } from "@/context/LanguageContext";
import { ABOUT_IMG } from "@/data/content";
import { Reveal, Overline } from "@/components/shared";

export const About = () => {
  const { t } = useLang();
  const a = t.about;

  return (
    <section id="about" data-testid="about" className="border-t border-zinc-200 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-24 sm:px-12 md:grid-cols-12 md:gap-16 md:py-32">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-28">
            <Reveal>
              <div className="relative overflow-hidden">
                <img src={ABOUT_IMG} alt="" className="aspect-[4/5] w-full object-cover" />
                <div className="absolute bottom-0 left-0 bg-zinc-900 px-6 py-4">
                  <span className="font-heading text-2xl font-light text-white">Meglio con Meno</span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <div className="md:col-span-7 md:pl-8">
          <Reveal>
            <Overline>{a.overline}</Overline>
            <h2 className="mt-6 font-heading text-3xl font-light tracking-tight text-zinc-900 sm:text-5xl">
              {a.title}
            </h2>
          </Reveal>
          <div className="mt-8 space-y-6">
            {a.paragraphs.map((p, i) => (
              <Reveal key={i} i={i + 1}>
                <p className="text-base leading-relaxed text-zinc-600 sm:text-lg">{p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
